import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getUser } from '../../../../store/reducers/user';
import styles from '../Header.module.scss';

const getPages = (user) => {
  const pages = [];
  if (user.contacts) {
    pages.push({
      label: 'Contacts',
      params: {
        page: 1,
        limit: 10,
        orderBy: 'address',
        fields: 'address,lists,segments,email',
      },
    });
  }
  pages.push({ label: 'Insights', val: 'dashboard' });
  pages.push({ label: 'Audiences' });
  pages.push({ label: 'Flows' });
  if (user.forms) {
    pages.push({ label: 'Forms' });
  }
  if (user.custom_dashboard_url) {
    pages.push({ label: 'Custom Insights', val: 'custom-insights' });
  }

  return pages;
};
const insightsRoutes = [
  'dashboard',
  'tracked-website',
  'nfts',
  'coins',
  'account',
  'my-team',
  'settings',
];
const audiencesRoutes = [
  'audiences',
  'segment',
  'add-segment',
  'custom-list',
  'add-custom-list',
  'wallet',
  'csv-upload',
];
const flowsRoutes = ['flows', 'add-flow'];
const formsRoutes = ['forms', 'add-form', 'form-analytics', 'form'];
const customInsightsRoutes = ['custom-insights'];

const Navigation = () => {
  const { pathname } = useLocation();
  const user = useSelector(getUser);
  const hasContactsPermission = !!user.contacts;
  const pages = getPages(user);

  const handleActiveLink = () => {
    const contactsOffset = hasContactsPermission ? 0 : 1;
    if (insightsRoutes.includes(pathname.split('/')[1]))
      return 1 - contactsOffset;
    if (audiencesRoutes.includes(pathname.split('/')[1]))
      return 2 - contactsOffset;
    if (flowsRoutes.includes(pathname.split('/')[1])) return 3 - contactsOffset;
    if (formsRoutes.includes(pathname.split('/')[1]) && user.forms) {
      return 4 - contactsOffset;
    }
    if (customInsightsRoutes.includes(pathname.split('/')[1]))
      return 5 - contactsOffset;
    return 0;
  };

  const handlePageTitle = () => {
    const urlEnd = pathname.split('/')[1];
    if (audiencesRoutes.includes(urlEnd)) return 'Audiences';
    if (flowsRoutes.includes(urlEnd)) return 'Flows';
    if (formsRoutes.includes(urlEnd) && user.forms) return 'Forms';
    if (customInsightsRoutes.includes(urlEnd)) return 'Custom Insights';
    if (insightsRoutes.includes(urlEnd)) return 'Dashboard';
    return 'Contacts';
  };

  // TODO: hidden navigation elements - tools and connect, uncomment when need
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{handlePageTitle()} - Absolute Labs Platform</title>
      </Helmet>
      <nav className="navbar navbar-expand-lg gap-3 pb-0">
        <ul className="nav nav-pills d-flex gap-2">
          {pages.map((elem, index) => (
            <li className="nav-item" key={[index]}>
              <Link
                to={`${elem.val || elem.label.toLowerCase()}${
                  elem.params
                    ? `?${new URLSearchParams(elem.params).toString()}`
                    : ''
                }`}
              >
                <button
                  className={`nav-link ${index === handleActiveLink() ? styles.active : ''}`}
                  aria-current="page"
                  type="button"
                >
                  {elem.label}
                </button>
              </Link>
            </li>
          ))}
        </ul>
        {/* {size.wight > 768 && ( */}
        {/*  <> */}
        {/*    <div className={styles.separator} /> */}
        {/*    <ul className="nav nav-pills d-flex gap-2"> */}
        {/*      {pagesNext.map((elem, index) => ( */}
        {/*        <li className="nav-item" key={[index]}> */}
        {/*          <Link className="nav-link" aria-current="page" to="/#"> */}
        {/*            {elem.label} */}
        {/*          </Link> */}
        {/*        </li> */}
        {/*      ))} */}
        {/*    </ul> */}
        {/*  </> */}
        {/* )} */}
      </nav>
    </>
  );
};

export default Navigation;
